import ResourceList from './ResourceList';

export default ResourceList;
